import { LodgmentType } from '../../../../domain/specification/lodgmentTypes/LodgmentType';

export const getCaseGranulometryEditLodgmentTypeTriggerId = (
  caseLabel: string,
  lodgmentType: LodgmentType
) => `case${caseLabel}EditLodgmentType${lodgmentType}`;
